(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('empleadosController', empleadosController);


    empleadosController.$inject = [
        '$templateCache',
        'empleadosService',
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        '$q',
        'notificationService',
        '$timeout',
        'preferences',
        'simpleModalService',
        'genericDataService',
        'common',
        'uiGridConstants',
        'restrictionService', 
        'userService'
    ];



    function empleadosController(
        $templateCache,
        empleadosService,
        $scope,
        $rootScope,
        $state,
        $filter,
        $q,
        notificationService,
        $timeout,
        preferences,
        simpleModalService,
        genericDataService,
        common,
        uiGridConstants,
        restrictionService, 
        userService
    ) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
            accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/empleados/accionesCellTemplate.html'),
            rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
            stateTemplate: $templateCache.get('app/views/tablesTemplates/empleados/stateTemplate.html'),
            nombreTemplate: $templateCache.get('app/views/tablesTemplates/empleados/nombreIconoTemplate.html'),
        };

        var sorting = {
            field: null,
            direction: null
        };

        var vm = this;

        vm.focusedRow = null;
        vm.loaded = false; 
        vm.empleados = []; 
        vm.gridData = [];
        vm.refreshData = refreshData; 
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            enableFilter: true,
            enableRowHeaderSelection: false, 
            enableRowSelection: false,
            multiSelect: false,
            enableSelectAll: false,
            enableFooterTotalSelected: false,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
            primaryKey: 'empleadoId',
            columnDefs: [
                // {
                //     field: 'tipoEmpleado',
                //     displayName: 'Tipo',
                //     cellTemplate: templates.stateTemplate,
                //     resizable: true,
                //     width: 40
                // },
                {
                    field: 'nombre',
                    cellClass: 'strong',
                    displayName: 'Nombre',
                    cellTemplate: templates.nombreTemplate,
                    resizable: true,
                    maxWidth: 180,

                },
                {
                    name: 'apellidos',
                    displayName: 'Apellidos',
                    resizable: true,
                    maxWidth: 250,

                },
                {
                    name: 'nif',
                    displayName: 'Nif',
                    resizable: true,

                },
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 100,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate,
                    enableSorting: false
                }

            ],
            data: 'gridData',

            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;
            }
        };

        vm.filterGrid = filterGrid;
        vm.goToEdit = goToEdit;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
        vm.remove = remove;
        vm.refreshGrid = refreshGrid;
        vm.changeGrid = changeGrid;
        vm.deleteAllItems = deleteAllItems;
        vm.focusRow = focusRow;
        vm.isFocused = isFocused;
        vm.deleteSearchData = deleteSearchData;
        vm.selectEmpresa = selectEmpresa; 
        vm.empleadosEmpresa = []; 

        vm.clearSearcher = clearSearcher;
        vm.searchText = '';

        (function () {
            loadData();
        })();

        function filterGrid() {
            if (vm.searchText !== '') {
                $scope.gridData = $filter('searchFilter')(vm.empleadosEmpresa, {
                    'nombre': vm.searchText,
                    'apellidos': vm.searchText,
                    'nif': vm.searchText
                }, true);
            }
            else {
                $scope.gridData = vm.empleadosEmpresa;
            }
            vm.gridOptions.totalItems = $scope.gridData.length;
            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }
        function refreshData() {
            loadData();
        }

        function loadData() {
            vm.loaded = false; 
            vm.searchText = ''; 

            clearAll();
            genericDataService.getEmpresasFromMaster().then(function(result) {
                vm.empresas = result.data; 
                vm.empresas.selected = {nombre: 'Todas', id: 0}; 
            }); 
            empleadosService.getAll().then(function (result) {
                vm.loaded = true; 
                vm.gridOptions.totalItems = result.length;
                vm.firstLoaded = true;
                vm.empleados = result; 
                vm.empleadosEmpresa = result; 

                $scope.gridData = result;
                vm.gridData = result;

            });
        }


        function selectEmpresa(empresa) {
            if(empresa == null) {
                vm.empleadosEmpresa = vm.empleados;
                vm.empresas.selected = {
                    nombre: 'Todas',
                    id: 0
                };
            }
            else {
                vm.empleadosEmpresa = vm.empleados.filter(x=> x.empresaId == empresa.empresaId);
                vm.empresas.selected = empresa;  
            }
            filterGrid(); 
        }

        function focusRow(empleado) {
            vm.focusedRow = empleado.empleadoId;
        }

        function isFocused(empleado) {
            return vm.focusedRow === empleado.empleadoId;
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }

        function clearAll() {
            if (!common.isNullOrUndefined(vm.gridApi))
                vm.gridApi.selection.clearSelectedRows();
        }

        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }

        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function goToEdit(empleado) {

            
            var ret = restrictionService.hasPermission(2, 'empleado', 'flota.editarEmpleado', {
                'id': empleado.empleadoId
            });
            if(ret != false) $rootScope.tabManager.tabs.splice($rootScope.tabManager.tabs.findIndex(x => x.title == 'Empleados'), 1);

        }

        function remove(empleado) {
            notificationService.sendAppNotification({
                message: 'Dando de baja empleado...',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
            empleadosService.deleteById([empleado.empleadoId]).then(function () {
                clearSearcher();
                vm.empleados.splice(vm.empleados.findIndex(x=> x.empleadoId == empleado.empleadoId),1); 
                notificationService.sendAppNotification({
                    message: 'Empleado dado de baja con éxito',
                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                });
            }, function () {
                notificationService.sendAppNotification({
                    message: 'Ha ocurrido un error al dar de baja el empleado',
                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                });
            });
        }

        function deleteAllItems() {
            if (!restrictionService.hasPermission('eliminar', 'empleado')) return; 

            simpleModalService
                .yesNoModal('Confirmación eliminar', '¿Desea eliminar los empleados seleccionados?') // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                .then(function (result) {
                    if (result) {
                        var empleadoIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            empleadoIds.push(selected[i].empleadoId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Dando de baja empleados...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        empleadoService.deleteById(empleadoIds)
                            .then(function () {
                                refreshGrid();
                                clearSearcher();
                                notificationService.sendAppNotification({
                                    message: 'empleados dados de baja con éxito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                            },
                                function () {
                                    notificationService.sendAppNotification({
                                        message: 'Ha ocurrido un error al dar de baja los empleados',
                                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                    });
                                });
                    }
                });
        }

        function refreshGrid() {
            loadData();
        }

        function deleteSearchData() {
            vm.searchText = '';
            filterGrid();
        }

        function changeGrid() {
            filterGrid();
        }

        function clearSearcher() {
            vm.searchText = '';
            filterGrid();
        }
    }

})();
